import { TransformNumberPipe } from './../../@shared/pipes/transform-number.pipe';
import { CommonDataDTO } from './../../requests/model/combos-model';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { OperationDetailRequestDTO, ReqOpsDetailsDTO } from '../models/control-panel.model';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import jsPDF from 'jspdf';
import autoTable, { Table } from 'jspdf-autotable';
import { ControlPanelStore } from '../control-panel-service/control-panel.store';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { pairwise, startWith } from 'rxjs/operators';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { MAX_SELECTOR_DATA } from '@app/@core/constants/material-custom.constants';
import FileSaver from 'file-saver';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { Credentials } from '@app/@core/models/login-models';
import {
  BUSINESS_DIRECTOR,
  CHAIN,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_DIRECTOR,
} from '@app/@core/constants/users.constants';
import {
  REQUEST_APPROVED,
  REQUEST_CANCELLED,
  REQUEST_DENIED,
  REQUEST_PAID_PENDING_VALIDATION,
  REQUEST_PENDING,
  REQUEST_PENDING_PAYMENT_INCIDENT,
  REQUEST_REGULARISE_PAID_VALIDATED,
  REQUEST_SIGNED,
  REQUEST_STUDYING,
  REQUEST_CONDITIONED_PENDING_FORMALIZATION,
} from '@app/@core/constants/requests.constants';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LOCALE_ES } from '@app/@core/constants/common.constants';

const moment = _moment;

const FORM_PARAM_MACRO_CHAIN = 'macroChain';
const FORM_PARAM_MACRO_OFFICE = 'macroOffice';

const emptyCommonDataDTO: CommonDataDTO = {
  id: '',
  value: '',
};

@UntilDestroy()
@Component({
  selector: 'app-operation-detail',
  templateUrl: './operation-detail.component.html',
  styleUrls: ['./operation-detail.component.scss'],
})
export class OperationDetailComponent implements OnInit {
  divisionList: CommonDataDTO[] = [];
  officeList: CommonDataDTO[] = [];
  statusList: CommonDataDTO[] = [];
  groupList: CommonDataDTO[] = [];
  agentList: CommonDataDTO[] = [];
  externalCommercialList: CommonDataDTO[] = [];
  originList: CommonDataDTO[] = [];
  macroChainList: CommonDataDTO[] = [];
  macroOfficeList: CommonDataDTO[] = [];

  requestOperationsList: Array<ReqOpsDetailsDTO[]> = [];

  private isCalledOnce: boolean = false;
  public operationDetailForm: FormGroup;

  maxDate: Date = new Date();
  maxFinalDate: Date;
  minDate: Date;

  userInfo: Credentials;
  officeChainList: CommonDataDTO[] = [];
  isMacroOfficeUser: boolean = false;
  isMacroChainUser: boolean = false;
  isBusinessDirector: boolean = false;

  private allData: any[] = [];
  public head = [
    'operationDetail.registerOffice',
    'operationDetail.request',
    'operationDetail.clientName',
    'operationDetail.originAgent',
    'operationDetail.vendor',
    'operationDetail.invest',
    'operationDetail.product',
    'operationDetail.article',
    'operationDetail.calification',
    'operationDetail.brand',
    'operationDetail.entrance',
    'operationDetail.resolution',
    'operationDetail.payDate',
    'operationDetail.division',
    'operationDetail.security',
    'operationDetail.over',
    'operationDetail.tir',
    'operationDetail.investmentComplement',
  ];
  private searchCriteria: OperationDetailRequestDTO;

  constructor(
    private formBuilder: FormBuilder,
    private controlPanelStore: ControlPanelStore,
    private loaderGenericService: LoaderGenericService,
    private customValidators: CustomValidatorsService,
    private excelService: ExcelService,
    private transformNumberPipe: TransformNumberPipe,
    private combosStore: CombosStore,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService
  ) {}

  ngOnInit() {
    this.loaderGenericService.showSpinner();

    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);

    this.operationDetailForm = this.formBuilder.group(
      {
        division: ['', Validators.required],
        office: [''],
        status: [''],
        group: [''],
        agent: [''],
        externalCommercial: [''],
        origin: [''],
        startDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        endDate: [{ value: '', disabled: true }, [Validators.required, this.customValidators.checkIsFutureDate]],
      },
      {
        validators: [
          this.customValidators.isDateValid('startDate', 'endDate', 'dateInvalid'),
          this.customValidators.isMoreThanAYearApart('startDate', 'endDate', 'dateYearError'),
        ],
      }
    );

    this.validateMacroChainUser();
    if (this.isBusinessDirector) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN, FORM_PARAM_MACRO_OFFICE]);
    else if (this.isMacroChainUser) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN]);
    else if (this.isMacroOfficeUser) this.initMacroUsers([FORM_PARAM_MACRO_OFFICE]);
    else this.getAllCombos();
    this.setUpObservableValueChanges();
  }

  getExcelAllIdsName(): string {
    return this.translateService.instant('excel.allIds');
  }

  private getAllCombos = () => {
    Promise.all([
      this.getDivision(),
      this.getOffices(),
      this.getStatus(),
      this.getGroups(),
      this.getAgents(),
      this.getExternalCommercial(),
      this.getOrigins(),
    ])
      .catch((error) => console.error(error))
      .finally(() => this.loaderGenericService.stopSpinner());
  };

  private setUpObservableValueChanges = () => {
    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.operationDetailForm.controls.startDate.statusChanges.subscribe((value) => {
      const initialDateValue = this.operationDetailForm.controls.startDate.value;
      if (value === 'VALID' || initialDateValue) {
        this.minDate = initialDateValue.toDate();
        this.maxFinalDate = moment(initialDateValue).add(11, 'months').endOf('month').toDate();
        if (this.operationDetailForm.controls.endDate.disabled) this.operationDetailForm.controls.endDate.enable();
      } else {
        this.minDate = undefined;
        this.maxFinalDate = this.maxDate;
      }
    });

    this.operationDetailForm.controls.division.valueChanges.subscribe(() => {
      this.clearAll();
    });

    this.operationDetailForm.controls.office.valueChanges.pipe(startWith(), pairwise()).subscribe(([prev, next]) => {
      if (this.operationDetailForm.controls.office.enabled && prev !== next && next !== undefined && next !== null) {
        this.loaderGenericService.showSpinner();
        if (next === '') {
          this.clearGroup();
          this.clearAgent();
          this.clearExternalCommercial();
          this.getOffices();
        }

        Promise.all([this.getGroups(), this.getAgents(), this.getExternalCommercial()])
          .catch((error) => console.error(error))
          .finally(() => this.loaderGenericService.stopSpinner());
      }
    });

    this.operationDetailForm.controls.group.valueChanges.pipe(startWith(), pairwise()).subscribe(([prev, next]) => {
      if (this.operationDetailForm.controls.group.enabled && prev !== next && next !== undefined && next !== null) {
        this.loaderGenericService.showSpinner();
        if (next === '') {
          this.clearAgent();
          this.clearExternalCommercial();
          this.getGroups();
        }
        Promise.all([this.getOffices(), this.getAgents(), this.getExternalCommercial()])
          .catch((error) => console.error(error))
          .finally(() => this.loaderGenericService.stopSpinner());
      }
    });

    this.operationDetailForm.controls.agent.valueChanges.pipe(startWith(), pairwise()).subscribe(([prev, next]) => {
      if (this.operationDetailForm.controls.agent.enabled && prev !== next && next !== undefined && next !== null) {
        this.loaderGenericService.showSpinner();
        if (next === '') {
          this.clearExternalCommercial();
          this.getAgents();
        }
        Promise.all([this.getOffices(), this.getGroups(), this.getExternalCommercial()])
          .catch((error) => console.error(error))
          .finally(() => this.loaderGenericService.stopSpinner());
      }
    });

    this.operationDetailForm.controls.externalCommercial.valueChanges
      .pipe(startWith(), pairwise())
      .subscribe(([prev, next]) => {
        if (
          this.operationDetailForm.controls.externalCommercial.enabled &&
          prev !== next &&
          next !== undefined &&
          next !== null
        ) {
          this.loaderGenericService.showSpinner();
          if (next === '') {
            this.getExternalCommercial();
          }
          Promise.all([this.getOffices(), this.getGroups(), this.getAgents()])
            .catch((error) => console.error(error))
            .finally(() => this.loaderGenericService.stopSpinner());
        }
      });
  };

  private enableFormControl = (param: string) => {
    if (param) {
      const form = this.operationDetailForm.controls;
      if (form[param]?.disabled) form[param].enable();
    }
  };

  private enableFormControls = () => {
    if (this.operationDetailForm) {
      Object.keys(this.operationDetailForm.controls).forEach((key) => {
        if (
          key !== FORM_PARAM_MACRO_CHAIN &&
          key !== FORM_PARAM_MACRO_OFFICE &&
          this.operationDetailForm.controls[key].disabled
        ) {
          this.operationDetailForm.controls[key].enable();
        }
      });
    }
  };

  private disableFormControl = (param: string) => {
    if (param) {
      const form = this.operationDetailForm.controls;
      if (form[param]?.enabled) {
        if (form[param].value) form[param].reset();
        form[param].disable();
      }
    }
  };

  private disableFormControls = () => {
    if (this.operationDetailForm) {
      Object.keys(this.operationDetailForm.controls).forEach((key) => {
        if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
          this.operationDetailForm.controls[key].reset();
          if (this.operationDetailForm.controls[key].enabled) {
            this.operationDetailForm.controls[key].disable();
          }
        }
      });
    }
  };

  private initMacroUsers = (formProperties: string[]) => {
    this.disableFormControls();
    formProperties.forEach((property) => {
      this.operationDetailForm.addControl(property, new FormControl('', Validators.required));
      this.initValueChangesMacroUser(property);
      if (property === FORM_PARAM_MACRO_CHAIN) this.loadMacroChains();
      else if (property === FORM_PARAM_MACRO_OFFICE) this.loadMacroOffices();
    });
  };

  private initValueChangesMacroUser = (property: string) => {
    this.operationDetailForm.controls[property].valueChanges.subscribe((value) => {
      if (value) {
        this.resetForm();
        this.resetAllComboLists();
        this.getAllCombos();
        if (this.isBusinessDirector)
          this.disableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.enableFormControls();
      } else {
        this.resetAllComboLists();
        if (this.isBusinessDirector)
          this.enableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.disableFormControls();
      }
    });
  };

  private resetAllComboLists = () => {
    this.divisionList = [];
    this.officeList = [];
    this.statusList = [];
    this.groupList = [];
    this.agentList = [];
    this.externalCommercialList = [];
    this.originList = [];
  };

  private resetForm = () => {
    Object.keys(this.operationDetailForm.controls).forEach((property) => {
      if (
        property !== FORM_PARAM_MACRO_CHAIN &&
        property !== FORM_PARAM_MACRO_OFFICE &&
        this.operationDetailForm.controls[property].value
      ) {
        this.operationDetailForm.controls[property].reset();
      }
    });
  };

  private validateMacroChainUser = () => {
    this.isMacroChainUser = this.userInfo.userType === MACRO_CHAIN;
    this.isMacroOfficeUser = this.userInfo.userType === MACRO_OFFICE;
    this.isBusinessDirector = this.userInfo.userType === BUSINESS_DIRECTOR;
  };

  private clearAll(): void {
    this.clearOffice();
    this.clearGroup();
    this.clearStatus();
    this.clearAgent();
    this.clearOrigin();
    this.clearExternalCommercial();
  }

  private clearOffice() {
    this.officeList = [];
    this.operationDetailForm.controls.office.reset();
  }

  private clearGroup() {
    this.groupList = [];
    this.operationDetailForm.controls.group.reset();
  }

  private clearAgent() {
    this.agentList = [];
    this.operationDetailForm.controls.agent.reset();
  }

  private clearExternalCommercial() {
    this.externalCommercialList = [];
    this.operationDetailForm.controls.externalCommercial.reset();
  }

  private clearStatus() {
    this.statusList = [];
    this.operationDetailForm.controls.status.reset();
  }

  private clearOrigin() {
    this.originList = [];
    this.operationDetailForm.controls.origin.reset();
  }

  private getDivision() {
    return this.combosStore
      .getDivisions()
      .then(
        (data) => {
          if (data) {
            this.divisionList = data;
            if (this.divisionList.length === 1) {
              this.operationDetailForm.controls.division.setValue(this.divisionList[0].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  private buildRequest = () => {
    let request: any = {
      establishmentId: this.operationDetailForm.controls.agent?.value,
      externalCommercialUserId: this.operationDetailForm.controls.externalCommercial?.value,
      chainId: this.operationDetailForm.controls.group?.value,
      officeId: this.operationDetailForm.controls.office?.value,
    };

    if (this.isBusinessDirector) {
      request = this.operationDetailForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { ...request, chainId: this.operationDetailForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN }
        : {
            ...request,
            officeId: this.operationDetailForm.controls[FORM_PARAM_MACRO_OFFICE].value,
            userType: OFFICE_DIRECTOR,
          };
    } else if (this.isMacroChainUser)
      request = {
        ...request,
        chainId: this.operationDetailForm.controls[FORM_PARAM_MACRO_CHAIN].value,
        userType: CHAIN,
      };
    else if (this.isMacroOfficeUser)
      request = {
        ...request,
        officeId: this.operationDetailForm.controls[FORM_PARAM_MACRO_OFFICE].value,
        userType: OFFICE_DIRECTOR,
      };

    Object.keys(request).forEach((property) =>
      request[property] === null || request[property] === undefined ? (request[property] = '') : null
    );
    return request;
  };

  private getOffices() {
    let filter = this.buildRequest();
    return this.combosStore
      .getOffices(filter)
      .then(
        (data) => {
          if (data) {
            this.officeList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
            if (this.officeList.length === 2) {
              this.operationDetailForm.controls.office?.setValue(this.officeList[1].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  private getStatus() {
    return this.controlPanelStore
      .getListStatus()
      .then(
        (data) => {
          if (data) {
            this.statusList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
            if (this.statusList.length === 2) {
              this.operationDetailForm.controls.status.setValue(this.statusList[1].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  private getGroups() {
    let filter: any = this.buildRequest();
    return this.combosStore.getChains(filter).then(
      (data) => {
        if (data) {
          this.groupList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
          if (this.groupList.length === 2) {
            this.operationDetailForm.controls.group.setValue(this.groupList[1].id);
          }
        }
      },
      (error) => console.error(error)
    );
  }

  private getAgents() {
    let filter: any = this.buildRequest();
    return this.combosStore
      .getEstablishments(filter)
      .then(
        (data) => {
          if (data) {
            this.agentList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
            if (this.agentList.length === 2) {
              this.operationDetailForm.controls.agent.setValue(this.agentList[1].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  private getExternalCommercial() {
    let filter = this.buildRequest();
    return this.controlPanelStore
      .getListExternalCommercialByFilter(filter)
      .then(
        (data) => {
          if (data) {
            this.externalCommercialList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
            if (this.externalCommercialList.length === 2) {
              this.operationDetailForm.controls.externalCommercial.setValue(this.externalCommercialList[1].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  private getOrigins() {
    return this.controlPanelStore
      .getListOrigins()
      .then(
        (data) => {
          if (data) {
            this.originList = data.length === 0 ? [emptyCommonDataDTO] : [emptyCommonDataDTO, ...data];
            if (this.originList.length === 2) {
              this.operationDetailForm.controls.origin.setValue(this.originList[1].id);
            }
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  }

  searchDetails() {
    this.controlPanelStore
      .getOperationDetailReport(this.operationDetailForm)
      .then(
        (data) => {
          const listRequests: Array<Array<ReqOpsDetailsDTO>> = [];
          for (let i = 0; i < 10; i++) {
            //Number of status requests
            listRequests[i] = [];
          }

          data.forEach((req) => {
            switch (req.situationId) {
              case REQUEST_APPROVED:
                listRequests[0].push(req);
                break;
              case REQUEST_PENDING:
                listRequests[1].push(req);
                break;
              case REQUEST_STUDYING:
                listRequests[2].push(req);
                break;
              case REQUEST_DENIED:
                listRequests[3].push(req);
                break;
              case REQUEST_PAID_PENDING_VALIDATION:
                listRequests[4].push(req);
                break;
              case REQUEST_REGULARISE_PAID_VALIDATED:
                listRequests[5].push(req);
                break;
              case REQUEST_CANCELLED:
                listRequests[6].push(req);
                break;
              case REQUEST_PENDING_PAYMENT_INCIDENT:
                listRequests[7].push(req);
                break;
              case REQUEST_SIGNED:
                listRequests[8].push(req);
                break;
              case REQUEST_CONDITIONED_PENDING_FORMALIZATION:
                listRequests[9].push(req);
                break;
              default:
                console.error('Couldn´t find the request type');
            }
          });
          this.requestOperationsList = listRequests.filter((array) => array.length > 0);

          //excel y pdf
          this.getSearchCriteria(this.operationDetailForm);
        },
        (error) => console.error(error)
      )
      .catch((error) => console.error(error))
      .finally(() => (this.isCalledOnce = true));
  }

  getSearchCriteria(form: FormGroup) {
    this.searchCriteria = {
      divisionId: form.controls.division?.value
        ? this.divisionList.filter((item) => item.id == form.controls.division?.value)[0].value
        : this.getExcelAllIdsName(),
      officeId: form.controls.office?.value
        ? this.officeList.filter((item) => item.id == form.controls.office?.value)[0].value
        : this.translateService.instant('excel.allIdsFem'),
      reqStatusId: form.controls.status?.value
        ? this.statusList.filter((item) => item.id == form.controls.status?.value)[0].value
        : this.getExcelAllIdsName(),
      groupId: form.controls.group?.value
        ? this.groupList.filter((item) => item.id == form.controls.group?.value)[0].value
        : this.getExcelAllIdsName(),
      agentId: form.controls.agent?.value
        ? this.agentList.filter((item) => item.id == form.controls.agent?.value)[0].value
        : this.getExcelAllIdsName(),
      extCommercialId: form.controls.externalCommercial?.value
        ? this.externalCommercialList.filter((item) => item.id == form.controls.externalCommercial?.value)[0].value
        : this.getExcelAllIdsName(),
      origin: form.controls.origin?.value
        ? this.originList.filter((item) => item.id == form.controls.origin?.value)[0].value
        : this.getExcelAllIdsName(),
      fromDate: moment(form.controls.startDate?.value).startOf('month').format('DD-MM-YYYY'),
      toDate: moment(form.controls.endDate?.value).endOf('month').format('DD-MM-YYYY'),
    };
  }

  chosenYearHandler(normalizedYear: Moment, controlName: string) {
    const control = this.operationDetailForm.get(controlName);
    const ctrlValue = control.value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      this.operationDetailForm.get(controlName).setValue(ctrlValue);
    } else {
      control.setValue(moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY'));
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, controlName: string) {
    const control = this.operationDetailForm.get(controlName);
    const ctrlValue = control.value;
    if (control.pristine) control.markAsDirty();
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      this.operationDetailForm.get(controlName).setValue(ctrlValue);
    } else {
      this.operationDetailForm
        .get(controlName)
        .setValue(
          moment(
            '1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(),
            'DD-MM-YYYY'
          )
        );
    }
    datepicker.close();
  }

  hasAnyOperation() {
    if (this.requestOperationsList) {
      return this.requestOperationsList.length > 0;
    }
  }

  hasNoOperation() {
    if (this.requestOperationsList && this.isCalledOnce) {
      return this.requestOperationsList.length === 0;
    }
  }

  getOrderedArray(isPDF: boolean): any[] {
    this.allData = [];
    this.allData = JSON.parse(JSON.stringify(this.requestOperationsList));

    this.allData = this.allData.map((value) => {
      return { status: value[0].statusDes, operations: [value] };
    });

    let dataPrint: any[] = [];
    this.allData.forEach((item: any, index: number) => {
      let arrayAux: any[] = [];

      item.operations[0].push({
        monthYear: '',
        regOffice: '',
        requestNumber: this.translateService.instant('excel.total.operation'),
        customerName: item.operations[0].length + ' ' + item.operations[0][0].statusDes,
        origAgent: '',
        seller: this.translateService.instant('excel.total.finance'),
        investment: item.operations[0][0].totalFunding,
        productId: '',
        articleId: '',
        brandRating: '',
        brand: '',
        entryDate: '',
        resolutionDate: '',
        paymentDate: '',
        divisionId: '',
        situationId: '',
        statusDes: '',
        over: this.translateService.instant('excel.total.TIR'),
        tir: item.operations[0][0].halfTir ? item.operations[0][0].halfTir : 0,
        seg: '',
        operationNumber: undefined,
        totalFunding: undefined,
        halfTir: undefined,
        compInv: '',
      });

      item.operations[0].forEach((element: any) => {
        const operation = this.setReqOpsDetailsDTO(element, isPDF);
        const dataExcelOrder = JSON.stringify(operation, [
          'regOffice', //1
          'requestNumber', //2
          'customerName', //3
          'origAgent', //4
          'seller', //5
          'investment', //6
          'productId', //7
          'articleId', //8
          'brandRating', //9
          'brand', //10
          'entryDate', //11
          'resolutionDate', //12
          'paymentDate', //13
          'divisionId', //14
          'seg', //15
          'over', //16
          'tir', //17
          'compInv',
        ]);
        const ObjectDataExcel = JSON.parse(dataExcelOrder);
        arrayAux.push(Object.values(ObjectDataExcel));
      });

      dataPrint.push({ status: this.allData[index].status, operations: [...arrayAux] });
    });
    return dataPrint;
  }

  private setReqOpsDetailsDTO(element: any, transformNumber: boolean) {
    element.regOffice = element.regOffice ? element.regOffice : '';
    element.requestNumber = element.requestNumber ? element.requestNumber : '';
    element.customerName = element.customerName ? element.customerName : '';
    element.origAgent = element.origAgent ? element.origAgent : '';
    element.seller = element.seller ? element.seller : '';
    element.investment = element.investment
      ? transformNumber
        ? this.transformNumberPipe.transform(element.investment)
        : element.investment
      : '';
    element.productId = element.productId ? element.productId : '';
    element.articleId = element.articleId ? element.articleId : '';
    element.brandRating = element.brandRating ? element.brandRating : '';
    element.brand = element.brand ? element.brand : '';
    element.entryDate = element.entryDate ? element.entryDate : '';
    element.resolutionDate = element.resolutionDate ? element.resolutionDate : '';
    element.paymentDate = element.paymentDate ? element.paymentDate : '';
    element.divisionId = element.divisionId ? element.divisionId : '';
    element.seg = element.seg ? element.seg : '';
    element.over = element.over ? element.over : '';
    element.tir = element.tir ? (transformNumber ? this.transformNumberPipe.transform(element.tir) : element.tir) : 0;
    return element;
  }

  createAllExcel() {
    let dataExcelPrint: any[] = this.getOrderedArray(false);
    const filename =
      this.translateService.instant('excel.requestDetail.filename') + moment().locale('es').format('DDMMYYYY');

    const excelAllData = {
      fileName: filename,
      headers: this.head.map((header) => this.translateService.instant(header)),
      data: dataExcelPrint,
      criteria: this.searchCriteria,
    };
    this.excelService.exportExcelOperationDetail(excelAllData);
  }

  createAllPdf() {
    let dataPrint: any[] = this.getOrderedArray(true);
    console.log(dataPrint);
    new Promise((reject) => {
      try {
        let doc = new jsPDF({
          orientation: 'landscape',
          format: [296.926, 209.804],
        });
        const date = moment().locale('es');
        const filename = this.translateService.instant('excel.requestDetail.filename') + date.format('DDMMYYYY');

        doc.setProperties({
          title: filename,
        });

        /* BODY */
        dataPrint.forEach((item) => {
          doc = this.createPDFTable(doc, item.operations, item.status);
        });

        let blob = doc.output('blob');

        FileSaver.saveAs(blob, filename);
        window.open(URL.createObjectURL(blob));
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }

  createPDFTable(doc: jsPDF, dataPdf: any, tableTitle?: string): jsPDF {
    const lastAutoTable: Table = (doc as any).lastAutoTable; //la tabla anterior
    const maxTableYCoordinate: number = 190;
    const tableYCoordinateFirstPage: number = 85;
    const topMargin = 45;

    //First time
    doc.setFontSize(10);

    let heightLastRow: number = 0;

    let startYTable: number;
    if (!lastAutoTable) {
      startYTable = tableYCoordinateFirstPage;
    } else {
      if (lastAutoTable.finalY) {
        if (lastAutoTable.finalY + 31 < maxTableYCoordinate) {
          startYTable = lastAutoTable.finalY + 14;
        } else {
          doc.addPage();
          startYTable = topMargin;
        }
      }
    }

    if (!lastAutoTable) {
      //Only first page
      //Second row
      const secondRowYCoordinate: number = 45;
      const secondRowXCoordinate: number = 14;

      doc.text(
        `${this.translateService.instant('excel.period')} Del ${this.searchCriteria.fromDate} al ${
          this.searchCriteria.toDate
        }`,
        secondRowXCoordinate,
        secondRowYCoordinate
      );
      doc.text(
        this.translateService.instant('excel.office') + this.searchCriteria.officeId,
        secondRowXCoordinate,
        secondRowYCoordinate + 5
      );
      doc.text(
        this.translateService.instant('excel.status') + this.searchCriteria.reqStatusId,
        secondRowXCoordinate,
        secondRowYCoordinate + 10
      );
      doc.text(
        this.translateService.instant('excel.group') + this.searchCriteria.groupId,
        secondRowXCoordinate,
        secondRowYCoordinate + 15
      );
      doc.text(
        this.translateService.instant('excel.agent') + this.searchCriteria.agentId,
        secondRowXCoordinate,
        secondRowYCoordinate + 20
      );
      doc.text(
        this.translateService.instant('excel.comercialExt') + this.searchCriteria.extCommercialId,
        secondRowXCoordinate,
        secondRowYCoordinate + 25
      );
      doc.text(
        this.translateService.instant('excel.origin') + this.searchCriteria.origin,
        secondRowXCoordinate,
        secondRowYCoordinate + 30
      );
    }

    autoTable(doc, {
      startY: startYTable,
      head: [this.head.map((header) => this.translateService.instant(header))],
      headStyles: { fillColor: '#969696' },
      pageBreak: 'auto',
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      margin: { top: topMargin },
      body: dataPdf.map(Object.values),
      styles: { fontSize: 8 },
      didDrawCell: (data) => {
        if (data.row.index === dataPdf.length - 1) {
          heightLastRow = data.row.height;
        }
      },
      didDrawPage: (data) => {
        if (
          !lastAutoTable ||
          (startYTable >= maxTableYCoordinate - 20 * 2 && data.pageNumber > 1) ||
          startYTable === topMargin
        ) {
          /* HEADER */
          //TITLE
          const headerXCoordinate: number = 80;
          const headerYCoordinate: number = 20;
          doc.setFontSize(24);
          doc.setTextColor('1E90FF');
          doc.text(this.translateService.instant('excel.dashboard.title'), headerXCoordinate, headerYCoordinate);

          //IMAGE
          let img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', 3, 10, 58, 20);

          //First row
          doc.setTextColor('#000000');
          doc.setFontSize(12);

          const firstRowYCoordinate: number = 35;
          const titleXCoordinate: number = 75;
          doc.text(this.translateService.instant('operationDetail.title'), titleXCoordinate, firstRowYCoordinate);
          doc.setFontSize(10);

          const thirdColumnXCoordinate: number = 150;
          doc.text(
            this.translateService.instant('excel.date') + moment().locale('es').format('DD-MM-YYYY HH:mm:ss'),
            thirdColumnXCoordinate,
            firstRowYCoordinate - 3
          );
          doc.text(
            this.translateService.instant('excel.pag') + doc.getNumberOfPages(),
            thirdColumnXCoordinate,
            firstRowYCoordinate + 3
          );
        }
        if (data.pageNumber === 1) doc.text(tableTitle, 14, startYTable - 2);
      },
    });

    return doc;
  }

  isAgentGenericSelect() {
    return this.agentList?.length < MAX_SELECTOR_DATA;
  }

  private loadMacroChains = async () => {
    this.resetForms();
    this.operationDetailForm.controls[FORM_PARAM_MACRO_CHAIN].reset();
    this.macroChainList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getChainsByDivision(this.userInfo.division?.toString())
      : this.combosStore.getChainsFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroChainList =
              this.isBusinessDirector && data.length > 0 ? [{ id: undefined, value: '' }, ...data] : [...data];
            if (this.macroChainList.length === 1)
              this.operationDetailForm.controls[FORM_PARAM_MACRO_CHAIN].setValue(this.macroChainList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
        }
      });
  };

  private loadMacroOffices = async () => {
    this.resetForms();
    this.operationDetailForm.controls[FORM_PARAM_MACRO_OFFICE].reset();
    this.macroOfficeList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getOfficesByDivision(this.userInfo.division?.toString())
      : this.combosStore.getOfficesFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroOfficeList =
              this.isBusinessDirector && data.length > 0 ? [{ id: undefined, value: '' }, ...data] : [...data];
            if (this.macroOfficeList.length === 1)
              this.operationDetailForm.controls[FORM_PARAM_MACRO_OFFICE].setValue(this.macroOfficeList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
        }
      });
  };

  private resetForms = (filter?: string[]) => {
    if (this.operationDetailForm) {
      Object.keys(this.operationDetailForm.controls).forEach((key) => {
        if (filter) {
          if (!filter.includes(key)) {
            this.operationDetailForm.controls[key]?.reset();
          }
        } else this.operationDetailForm.controls[key]?.reset();
      });
    }
  };
}
